import { ArrowBack } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router-dom'
import ReportCard from '../Reports/components/ReportCard';
import DeviceLog from 'packages/novous_web/src/assets/icons/document.svg';
import docfile from 'packages/novous_web/src/assets/icons/docfile.svg'
import baseTemplate from 'packages/novous_web/src/assets/icons/details.svg'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';

const Customization = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <div className='flex flex-col gap-4 w-full'>

      <div className='w-full relative'>
        <div className="w-full mb-2">
          <button className="text-blue-600 font-medium flex items-center" onClick={() => navigate(-1)}>
            <ArrowBack className="mr-1" /> Back
          </button>
        </div>
        {user.authorities === "ROLE_SUPER_ADMIN" &&
          <div className='w-full relative mt-4'>
            <div className="max-w-max">
              <div className="dashboard-header-left">
                <Box className="flex flex-col items-start">
                  <Typography variant="h4" fontSize="24px" fontWeight={600} lineHeight='36px'>
                    Device Management
                  </Typography>
                  <Typography variant="subtitle1" fontSize={16} fontWeight={400} lineHeight='24px' sx={(theme) => ({
                    color: theme.palette.secondary.main,
                  })}>
                    Manage device settings, logs, updates, and configurations for smooth fleet operations.
                  </Typography>
                </Box>
              </div>
            </div>
            <div className='w-full grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 relative my-4 gap-4'>
              <ReportCard
                imgSrc={DeviceLog}
                heading="Device Logs"
                overlineText="Monitor, export, and delete device logs to maintain clean and accessible data records. Manage stored data securely to ensure optimal device performance."
                navigateTo="device-logs"
                viewButton={{
                  navigateTo: "device-logs",
                  icon: <ArrowOutwardIcon />
                }}
              />
              <ReportCard
                imgSrc={DeviceLog}
                heading="Device Updates"
                overlineText="Keep devices updated with the latest features and fixes. Upload application files or use OTA upgrades to ensure devices perform optimally."
                navigateTo="device-updates"
                viewButton={{
                  navigateTo: "device-updates",
                  icon: <ArrowOutwardIcon />
                }}
              />
            </div>
          </div>
        }
        <div className='w-full relative mt-4'>
          <div className="max-w-max">
            <div className="dashboard-header-left">
              <Box className="flex flex-col items-start">
                <Typography variant="h4" fontSize="24px" fontWeight={600} lineHeight='36px'>
                  Alerts
                </Typography>
                <Typography variant="subtitle1" fontSize={16} fontWeight={400} lineHeight='24px' sx={(theme) => ({
                  color: theme.palette.secondary.main,
                })}>
                  Configure alerts and notifications to improve driver safety and fleet monitoring.
                </Typography>
              </Box>
            </div>
          </div>
          {/* {user?.id !== '65e993a3b43dc022c97d4185' && user?.id !== "6785fc4ec374c37790451da9" && user?.id !== "680732d5b5ca2f57d3a6c17c" && user?.id !== "682f2eade77e68390abc52f5" && */}
          {/* {(user?.authorities === "ROLE_SUPER_ADMIN" || user?.authorities === "ROLE_ADMIN") && ( */}
            <div className='w-full grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 relative my-4 gap-4'>
              <ReportCard
                imgSrc={DeviceLog}
                heading="Manage Alerts"
                overlineText="Tailor alerts to improve fleet safety, driver performance, and operational efficiency. Enable, adjust, and prioritize alerts to suit your fleet's unique requirements."
                navigateTo="manage-alerts"
                viewButton={{
                  navigateTo: "manage-alerts",
                  icon: <ArrowOutwardIcon />
                }}
              />
            </div>
          {/* )} */}
          {/* } */}
        </div>
      </div>

    </div>
  )
}

export default Customization